import AbstractResource from './abstract'

class Options extends AbstractResource {
    resourceName = 'options'
}

export default Options


// WEBPACK FOOTER //
// ./src/services/wpapi/ressources/Options.js